export default __webpack_public_path__ + "static/media/token.844b5e03.png";